module.exports = __webpack_public_path__ + "static/media/icon_inserat_aufschalten.c06821e1.png";